import type { FetchByQueryResult, Segment } from "mobx-repository";
import { prop } from "ramda";
import type {
    PageInfo,
    ShockProfile,
    ShockProfilesListShockProfilesRequest,
    ShockProfileVersionsApi,
} from "../../api";
import type { ApiResource } from "../../utils/elofleet-repository";
import { ElofleetRepository } from "../../utils/elofleet-repository";
import type { UUID } from "../../utils/uuid";

export type ShockProfilesQuery = Omit<ShockProfilesListShockProfilesRequest, "page">;

export interface ShockProfileVersionsApiResource extends ApiResource {
    entity: ShockProfile;
    query: never;
    update: never;
    create: never;
    sortKey: never;
}

export class RepositoryShockProfileVersions extends ElofleetRepository<ShockProfileVersionsApiResource> {
    constructor(private readonly shockProfileVersionsApi: ShockProfileVersionsApi) {
        super();
    }

    protected async fetchById(versionId: UUID): Promise<ShockProfile | undefined> {
        return await this.shockProfileVersionsApi.shockProfileVersionsReadShockProfileVersion({
            versionId,
        });
    }

    protected extractId = prop("id");

    public fetchMetadata(_query: never): Promise<PageInfo> {
        throw new Error("Method not implemented.");
    }

    public update(_id: string, _update: never): Promise<ShockProfile> {
        throw new Error("Method not implemented.");
    }

    public create(_update: never): Promise<ShockProfile> {
        throw new Error("Method not implemented.");
    }

    public delete(..._ids: string[]): Promise<void> {
        throw new Error("Method not implemented.");
    }

    protected fetchByQuery(
        _query: never,
        _pagination: Segment,
    ): Promise<FetchByQueryResult<ShockProfile>> {
        throw new Error("Method not implemented.");
    }
}
